import type { ImplementationTypology } from './enums/implementation-typology.js'
import type { NetworkDashboardStoreAgeFilter } from './index.js'

export const STORE_AGE_BRACKETS = [
  'less_than_3_months',
  'between_3_and_6_months',
  'between_6_and_12_months',
  'more_than_12_months',
] as const satisfies readonly NetworkDashboardStoreAgeFilter[]
export type StoreAgeBracket = (typeof STORE_AGE_BRACKETS)[number]

export const SAVED_STORE_SELECTION_NAME_MAX_LENGTH = 80
export const SAVED_STORE_SELECTIONS_MAX_PER_ADMIN = 50

export interface SavedStoreSelectionInput {
  name: string
  storeIds: number[]
  ages: StoreAgeBracket[]
  typologies: ImplementationTypology[]
}

export interface SavedStoreSelection extends SavedStoreSelectionInput {
  id: number
  createdAt: string
}
